import { API } from "./brand";

const SESSION_KEY = "helios.ai-chat.session";
export function readChatSession() {
  try { const id = window.sessionStorage.getItem(SESSION_KEY); return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id || "") ? id : null; } catch { return null; }
}
export function saveChatSession(id) {
  try { if (id) window.sessionStorage.setItem(SESSION_KEY, id); else window.sessionStorage.removeItem(SESSION_KEY); } catch { /* Conversation remains available in this page when storage is disabled. */ }
}
async function checkResponse(response) {
  if (response.ok) return response;
  const body = await response.json().catch(() => ({}));
  throw new Error(typeof body.detail === "string" ? body.detail : "Helios could not connect. Please try again.");
}
export async function loadChatSession(id, signal) {
  const response = await fetch(`${API}/chat/sessions/${id}`, { signal, cache: "no-store" });
  if (response.status === 404) return null;
  return (await checkResponse(response)).json();
}
export async function deleteChatSession(id) {
  await checkResponse(await fetch(`${API}/chat/sessions/${id}`, { method: "DELETE" }));
}
export async function streamHeliosChat(payload, signal, onDelta, onStatus) {
  const response = await checkResponse(await fetch(`${API}/chat/stream`, {
    method: "POST", signal, headers: { "Content-Type": "application/json", Accept: "text/event-stream" }, body: JSON.stringify(payload)
  }));
  if (!response.body || !response.headers.get("content-type")?.includes("text/event-stream")) throw new Error("The chat connection returned an unexpected response.");
  const reader = response.body.getReader(), decoder = new TextDecoder();
  let buffer = "";
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      const frames = buffer.split("\n\n"); buffer = frames.pop();
      for (const frame of frames) {
        const event = frame.split("\n").find(line => line.startsWith("event:"))?.slice(6).trim();
        const data = frame.split("\n").filter(line => line.startsWith("data:")).map(line => line.slice(5).trim()).join("\n");
        if (!data) continue;
        const result = JSON.parse(data);
        if (event === "status") onStatus(result);
        if (event === "token") onDelta(result.delta);
        if (event === "error") throw new Error(result.message);
        if (event === "complete") return result;
      }
      if (done) throw new Error("The reply was interrupted. Retry to complete it.");
    }
  } finally { await reader.cancel().catch(() => {}); }
}